export default __webpack_public_path__ + "static/media/record-player.09a917c1.jpg";